<div class="balance" routerLink="/profile/deposit">
  <div class="icons-block">
    <img loading="lazy" class="balance__icon sm:hidden" [src]="'/assets/img/new-categories/balance.png'" alt="">
    <img loading="lazy" class="balance__icon hidden sm:block" [src]="'/assets/img/new-categories/balance-mobile.png'" alt="">
    <span class="balance__label-header">{{'h.deposit' | translate}}</span>
  </div>
  @if (balanceValueSignal(); as v) {
    <span class="balance__label">
      {{ v.leftToken }} {{ v.amount | currencyFormat:v.code }}
    </span>
  }
</div>
<div class="actions">
  <button class="btn btn--filled-primary" (click)="onDepositClick(!motivateWithdrawal.isMotivateWithdrawalAvailable)" routerLink="/profile/deposit">{{(motivateWithdrawal.isMotivateWithdrawalAvailable ? 'btn.cashout' : 'btn.deposit') | translate}}</button>
</div>
<span class="username" routerLink="/profile/account">{{ user.info.nickname }}</span>
@if (userImg()) {
  <img loading="lazy" routerLink="/profile/account" class="username__icon" [src]="userImg()" alt="user-icon">
}

